import React from 'react'
import About from './About';
import Feature from './Feature';
import Service1 from './Service1';
import Sponsor from './Sponsor';
import Testimonials from './Testimonials';
import Team from './Team';
import Blog from './Blog';
import CalltoAction from './CalltoAction';
import Banner from './Banner';
import SEO from '../Components/seo';
import Secbann from './Secbann';

const Home = () => {
  return (
    <div>
        <SEO 
        title="IoT & Software Development Company | Custom Smart Solutions & Software solutions | Vincosys"
        description="End-to-end IoT services including hardware design, firmware development, and real-time data analytics. Perfect for smart homes, wearables, and industrial automation."
        keywords="IoT solutions,IoT development services,Smart device development,Industrial IoT (IIoT),IoT cloud integration,IoT sensor networks,IoT data analytics,IoT for smart homes/cities,IoT security solutions,Custom software development,Mobile app development,Best web development,APP developmet"
      />
      <Secbann/>
        {/* <Banner/> */}
          {/* About section */}
          <About />
          {/* <Feature /> */}
          <Service1 />
          {/* <CalltoAction/> */}
          {/* <Sponsor /> */}
          {/* <Testimonials /> */}
          {/* <Team /> */}
          {/* <Blog/> */}
    </div>
  )
}

export default Home
